import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f7b299b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fp" }
const _hoisted_2 = { class: "fp_header" }
const _hoisted_3 = {
  key: 0,
  class: "fp_header_x"
}
const _hoisted_4 = { class: "fp_x" }
const _hoisted_5 = { class: "fp_list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "fp_list_item_header" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "tags"
}
const _hoisted_11 = {
  key: 2,
  class: "warning"
}
const _hoisted_12 = {
  key: 3,
  class: "warning success"
}
const _hoisted_13 = {
  key: 4,
  class: "warning fail"
}
const _hoisted_14 = { class: "fp_list_item_nr" }
const _hoisted_15 = {
  key: 0,
  class: "item"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "工序名称：", -1))
const _hoisted_17 = { class: "item_nr" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "计划日期：", -1))
const _hoisted_20 = { class: "item_nr" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "计划数量：", -1))
const _hoisted_23 = { class: "item_nr" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "生产批次：", -1))
const _hoisted_26 = { class: "item_nr" }
const _hoisted_27 = { class: "item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "库存：", -1))
const _hoisted_29 = { class: "item_nr" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fp_zw" }, null, -1))

import { Toast } from 'vant'
    import { reactive, ref } from "vue"
    import { useRouter } from "vue-router"
    import { useStore } from "vuex"
    import { getWorkingProcedure, getList, getSelfList } from '@/apis/PlanningAPI'
    import { model } from '@/interface'
    import vLableSelection from '@/components/common/LabelSelection.vue'

    // 搜索接口
    interface search extends model {
        gxId: number | string,
        total: number,
        first: boolean,
    }

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const store = useStore()

    const router = useRouter()

    let list: any = ref([])
    const loading = ref(false)
    const finished = ref(false)
    const refreshing = ref(false)

    const search = reactive<search>({
        gxId: '',
        capacity: 10,
        page: 0,
        total: 0,
        mixParam: '',
        first: true // 用于判断是否是第一次进入页面
    })

    // 标签搜索项
    let tagList: any = ref([])

    // 点击当前项
    const clickItem = (i: number) => {
        list.value.forEach((item: any, index: number) => {
            item.isActive = i === index;
        })
    }

    // 搜索
    const searchInput = (e: string) => {
        search.mixParam = e
        search.page = 0
        list.value = []
        finished.value = false
        getLists()
    }

    // 点击
    const clickTag = (id: any): void => {
        search.gxId = id
        list.value = []
        search.page = 0
        finished.value = false
        getLists()
    }

    // 分配
    const submit = () => {
        let data: any;
        list.value.forEach((item: any) => {
            if (item.isActive) {
                data = item
            }
        })
        if (!data) {
            return Toast('至少选择一项计划！')
        }
        router.push({ path: '/distribution/assignUsers', query: { gxid: data.procedureId, jhid: data.id, num: data.workorderDistributNum ? data.num - data.workorderDistributNum : data.num } })
    }

    // 获取当前用户所分配的工序
    const getWorkingProcedures = async (): Promise<boolean> => {
        let res = await getSelfList({})
        if (res.code === 200 && res.data.length > 0) {
            let arr: { name: any; id: any }[] = []
            res.data.forEach((item: any) => {
                arr.push({ name: item.name, id: item.id })
            })
            search.gxId = arr[0].id
            tagList.value = arr
            return true
        }
        return false
    }

    // 获取计划列表数据
    const getLists = async () => {
        if (!finished.value) {  // 判断数据是否全部加载完成
            loading.value = true
            search.page = search.page + 1
            if (search.first) {     // 如果是第一次，先请求工序
                await getWorkingProcedures()
                let res = await getList({
                    capacity: search.capacity,
                    page: search.page,
                    model: {
                        mixParam: search.mixParam,
                        procedureId: search.gxId,
                        statusList: [1, 4]
                    }
                })
                loading.value = false
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                if (res.code === 200 && res.data.records.length !== 0) {
                    search.total = res.data.total
                    res.data.records.forEach((item: any) => {
                        item.isActive = false
                    })
                    list.value.push(...res.data.records)
                } else {
                    finished.value = true;
                }
                search.first = false
            } else {
                let res = await getList({
                    capacity: search.capacity,
                    page: search.page,
                    model: {
                        mixParam: search.mixParam,
                        procedureId: search.gxId,
                        statusList: [1, 4]
                    }
                })
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                loading.value = false
                if (res.code === 200 && res.data.records.length !== 0) {
                    res.data.records.forEach((item: any) => {
                        item.isActive = false
                    })
                    list.value.push(...res.data.records)
                    search.total = res.data.total
                } else {
                    finished.value = true;
                }
            }
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        search.page = 0
        loading.value = true;
        getLists();
    }

return (_ctx: any,_cache: any) => {
  const _component_v_Search = _resolveComponent("v-Search")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_Search, {
        onSearchInput: searchInput,
        placeholder: "搜索物料名称/编码"
      }),
      (_unref(tagList).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (_unref(tagList).length > 0)
        ? (_openBlock(), _createBlock(vLableSelection, {
            key: 1,
            TagList: _unref(tagList),
            isShow: false,
            onChange: clickTag
          }, null, 8, ["TagList"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, "共" + _toDisplayString(_unref(search).total) + "条数据", 1),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: getLists
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fp_list_item",
                  key: item.id,
                  onClick: ($event: any) => (clickItem(i))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: item.isActive
                    }, null, 8, _hoisted_8),
                    (item.mmodel)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.mmodel.name), 1))
                      : _createCommentVNode("", true),
                    (item.urgent)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "优先" + _toDisplayString(item.urgent), 1))
                      : _createCommentVNode("", true),
                    (item.type === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "返工"))
                      : (item.type === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "正常"))
                        : (item.type === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "异常"))
                          : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (item.pmodel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, _toDisplayString(item.pmodel.name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.planDate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, _toDisplayString(item.num), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, _toDisplayString(item.batch), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, _toDisplayString(item.isStock === 0 ? '不满足' : '满足'), 1)
                    ])
                  ])
                ], 8, _hoisted_6))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_30,
    _createElementVNode("div", { class: "fp_footer" }, [
      _createElementVNode("div", {
        class: "fp_footer_button",
        onClick: submit
      }, "分配")
    ])
  ]))
}
}

})